import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { keys } from 'lodash'
import { getCsvFile } from '../../utils/csvdownload'
import TrendFacilitationHeader from '../../components/TrendFacilitationHeader'
import SideCountriesSelector from '../../components/SideCountriesSelector'
import SideCountryTrends from '../../components/SideCountryTrends'
import ScatterPlot from '../../components/ScatterPlot'
import Modal from '../../components/Modal'
import { loadThirdPillar, unloadThirdPillar, loadLatestByIndicator,
  setSelectedCountry, setComparisonCountry,
  setSelectedCountryData, setComparisonCountryData } from '../../state/actions'


import './index.css'

const INDICATORS_LIST = [
  'ETIB',
  'CUSTSERVIND',
  'CLEAREFF',
  'TABTIMEIMPDOC',
  'TABTIMEIMPBORD',
  // 'IMPTIMECOMPLIANCEIDX',
  'TABCOSTIMPDOC',
  'TABCOSTIMPBORD',
  // 'IMPCOSTCOMPLIANCEIDX',
  'TABTIMEEXPDOC',
  'TABTIMEEXPBORD',
  // 'EXPTIMECOMPLIANCEIDX',
  'TABCOSTEXPDOC',
  'TABCOSTEXPBORD',
  // 'EXPCOSTCOMPLIANCEIDX',
  'EOSQ147',
  'EOSQ395',
  'CUSTTRANSPIND'
]


const ThirdPillarLegend = ({close}) => {
  return (
    <Modal close={close}>
        <img src="/legend/01.png" alt="Legend"/>
    </Modal>
  )
}


class ThirdPillar extends React.PureComponent {

  state = {
    legend: false
  }

  componentWillMount(){
    this.props.loadThirdPillar()
    if(!this.props.latestDataByIndicator){
      this.props.loadLatestByIndicator()
    }
    const { match, setSelectedCountry } = this.props
    const { countryCode } = match.params
    if(countryCode){
      setSelectedCountry(countryCode)
    }
  }

  componentWillUnmount(){
    this.props.unloadThirdPillar()
    this.props.setSelectedCountry(null)
    this.props.setSelectedCountryData(null)
    this.props.setComparisonCountry(null)
    this.props.setComparisonCountryData(null)
  }

  toggleLegend = (e) => {
    this.setState({legend:!this.state.legend})
  }

  downloadCsv =  (e) => {
    const { countries } = this.props
    getCsvFile(`third-pillar.csv`, keys(countries).sort(), INDICATORS_LIST)
  }


  render() {
    const { indicators, selectedCountry, thirdPillarData } = this.props
    const indicatorsList = INDICATORS_LIST.map(code => indicators[code])
    //const indicatorsList = indicatorsCodes.map(code => indicators[code]).filter(i => i.parentCategoryGlobalId ==  "ETI.B.03" && i.domain)

    return (
      <div>
        <TrendFacilitationHeader/>
        <div className="h-container cf">
          { this.state.legend && <ThirdPillarLegend close={this.toggleLegend}/> }
          <div className="fl-l w-40-l ph4">
            <h2 className="text-blue text-medium">Efficiency and transparency of border administration</h2>

            <div className="cf">
              <div className="w-third fl tc">
                <span onClick={this.toggleLegend}
                  className="explore-link link-lightblue underline pointer" to="/topics/ETIB03">LEGEND</span>
              </div>
              <div className="w-third fl tr">
                <a className="explore-link link-lightblue underline pointer" onClick={this.downloadCsv}>DOWNLOAD</a>
              </div>
            </div>

            { (selectedCountry === null) && (
              <div className="leftside-text text-gray">
                <p>
                 Transparent and efficient procedures at borders are key for the smooth functioning of international trade.
                </p>
                <p>
                Ranging on a scale from 1 (worst) to 7 (best), this indicator captures efficiency, transparency and costs  associated with importing and exporting goods. It  includes an assessment of the range, quality and  comprehensiveness of key services offered by  customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The indicator also assesses the time predictability of border procedures, as well as the transparency of the process—as measured by the availability and quality of information provided by border agencies—and the prevalence of corruption.
                </p>
                <p>
                It is one of the pillars of the Enabling Trade Index, co-published in 2016 by the Global Alliance for Trade Facilitation and the World Economic Forum. It aggregates 13 indicators collected from different sources.                </p>
                <p>
                To explore the results of each economy, click on the dots of the scatterplot.
                </p>
                {/* <p>
                  By selecting a country on the navigation
                  header, all visualsation will have the
                  Country Selected.
                </p> */}
              </div>
            ) }
            { (selectedCountry !== null) && (
              <div>
                <SideCountriesSelector/>
                <SideCountryTrends indicatorsList={indicatorsList}/>
              </div>
            ) }
          </div>
          <div className="fl-l w-60-l ph5">
            <div className="pt2">
              <div className="cf">
                <Link className="link-orange no-underline hero-top-link fr pa2 mb3" to="/trade-facilitation-policies">
                  <small>TRADE FACILITATION POLICIES &gt;</small>
                </Link>
              </div>
              {thirdPillarData && (
                <div className="ThirdPillar__chart_container">
                  <ScatterPlot data={thirdPillarData}/>
                </div>
              )}
              <div className="cf">
                <p className="no-underline hero-top-link fr pa2 mb3">
                  <small>Source: Global Alliance for Trade Facilitation – World Economic Forum; Enabling Trade Index</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  selectedCountry: state.selectedCountry,
  comparisonCountry: state.comparisonCountry,
  thirdPillarData: state.thirdPillar.data,
  latestDataByIndicator: state.latestDataByIndicator.data,
})

const mapDispatchToProps = { loadThirdPillar, unloadThirdPillar,
  loadLatestByIndicator, setSelectedCountry, setComparisonCountry,
  setSelectedCountryData, setComparisonCountryData }

export default connect(mapStateToProps, mapDispatchToProps)(ThirdPillar)



// WEBPACK FOOTER //
// ./src/pages/ThirdPillar/index.js